import enviro from 'enviro';

const SURVEY_MONKEY_APP_IDS = {
  QA: 1160471,
  PROD: 35186,
} as const;

export const SURVEY_MONKEY_APP_ID = enviro.isQa()
  ? SURVEY_MONKEY_APP_IDS.QA
  : SURVEY_MONKEY_APP_IDS.PROD;
